// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falPlus: CreateIconOptions = {
  "displayName": "FALPlus",
  "viewBox": "0, 0, 448, 512",
  "d": "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z"
};
